import type { Ref } from "vue";

export function toggleFunc(ref: Ref<boolean>) {
  return (activate?: boolean) => (ref.value = activate ?? !ref.value);
}

export function toggled(ref: Ref<boolean>, activate?: boolean) {
  return activate ?? !ref.value;
}
